import { getCoreDataDictionaryObjectNamesAsyncSlice } from './get';

export const { requestGetCoreDataDictionaryObjectNames, resetGetCoreDataDictionaryObjectNames } =
	getCoreDataDictionaryObjectNamesAsyncSlice.asyncActionCreators;
